<template>
  <div class="dummy-status">
    <img src="@/assets/images/empty-content/img-empty.svg" alt="empty tab">
    <div class="dummy-text" v-html="title" />
    <RouterLink v-if="btn && routeName" :to="{ name:routeName, params:{ locale: $i18n.localePath(), id: pageId} }"
                class="mk-btn mk-btn--default"
    >
      {{ btn }}
    </RouterLink>
    <a v-else-if="btn" href="btnLink" class="mk-btn mk-btn--default">
      {{ btn }}
    </a>
  </div>
</template>

<script>

export default {
  name: 'DummyStatus',
  props: {
    title: {
      type: String,
      default: ''
    },
    btn: {
      type: String,
      default: ''
    },
    btnLink: {
      type: String,
      default: ''
    },
    routeName: {
      type: String,
      default: ''
    },
    pageId: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/component/button.scss';

.dummy-status{
  text-align: center;
  margin: 72px 0;
  .dummy-text{
    font-size: 20px;
    font-weight: 500;
    line-height: 1.95;
    letter-spacing: normal;
    color: $grey-50;
    margin: 24px 0;
    a{
      text-decoration: none;
      color: $theme-red;
      margin: 0 4px;
      font-size: 20px;
    }
  }
  .mk-btn{
    width: auto;
    font-size: 24px;
    line-height: 1.63;
    padding: 10px 40px;
  }
}
</style>
<style lang="scss">

</style>
